export default __webpack_public_path__ + "static/media/Prologue_Aurora1.df13ec14.png";